export const FILE_STATUS_CREATED = "0"
export const FILE_STATUS_INPROGRESS = "1"
export const FILE_STATUS_COMPLETED = "2"
export const FILE_STATUS_DELETED = "3"
export const FILE_STATUS_FAILED = "4"
